










































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Card from '@/stories/utils/card.vue'


@Component({
  components: {
    Card,
  }
})
export default class StorybookButton extends Vue {
  get menuList() {
    return [
      {
        key: '1',
        title: 'test1',
        icon: 'far fa-pen',
      },
      {
        key: '2',
        title: 'test2',
        icon: 'far fa-pen',
      }
    ]
  }
}
